
import {Component, ChangeDetectionStrategy, input} from '@angular/core';

@Component({
    selector: 'light-button',
    templateUrl: './light-button.component.html',
    styleUrls: ['./light-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class LightButtonComponent {
  readonly iconName = input.required<string>();
  readonly label = input<string>("");

  readonly type = input<'white' | 'transparent'>('white');

  readonly disabled = input<boolean>(false);

  constructor() {
  }
}
